import { Injectable } from '@angular/core';
import { ApiService } from '@app/shared/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class CitiesService {
  constructor(private apiService: ApiService) {}

  getCities = () => this.apiService.get('/city');
}
